// Generated by Melange

import * as Fx from "../../fx/fx.jsx";
import * as Stdlib__Bool from "melange/bool.jsx";
import * as Stdlib__Int from "melange/int.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Subsonic__ArtistInfo from "./artistInfo.jsx";
import * as Subsonic__Utils from "./utils.jsx";

function make(id, count, includeNotPresent, param) {
  const params = {};
  return Fx.Monad_syntax.let$star((params["id"] = {
    TAG: /* Value */ 1,
    _0: id
  }, Stdlib__Option.iter((function (count) {
    params["count"] = {
      TAG: /* Value */ 1,
      _0: Stdlib__Int.to_string(count)
    };
  }), count), Stdlib__Option.iter((function (includeNotPresent) {
    params["includeNotPresent"] = {
      TAG: /* Value */ 1,
      _0: Stdlib__Bool.to_string(includeNotPresent)
    };
  }), includeNotPresent), Subsonic__Utils.makeRequest({
    _method: "rest/getArtistInfo2",
    params: params
  }, Subsonic__ArtistInfo.of_json)), (function (param) {
    return {
      TAG: /* Ok */ 0,
      _0: param.response.artistInfo2
    };
  }));
}

export {
  make,
}
/* No side effect */
